import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {GradeService} from '../../apiModule1';

export const gradeEditResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: GradeService = inject(GradeService)) => {
  return service.apiGradeIdGet({id: route.params['id']});
};
